module.exports = __webpack_public_path__ + "static/img/48f99cd5789369e59b5d0209c5f7394.6a2efec1.png";